/**
 * Converts a base64 string to a valid data URI for use in Image components.
 * If the string already starts with "data:image", it is returned as-is.
 * Otherwise, it is prefixed with "data:image/png;base64,".
 */
export const convertBase64ToDataUri = (base64: string) => {
  if (base64.startsWith("data:image")) {
    return base64;
  }
  return `data:image/png;base64,${base64}`;
};
